import { COLOR_PALETTE } from 'constants/ui';

// Light mode keeps the existing red/green; on the dark surface those fall below 4.5:1, so dark mode uses the dark
// palette's error/success tokens instead.
export const oldValueStyles = {
  color: ({ palette }) => (palette.mode === 'dark' ? palette.error.main : COLOR_PALETTE.RED[7]),
  textDecoration: 'line-through',
  wordBreak: 'break-word',
};

export const newValueStyles = {
  color: ({ palette }) => (palette.mode === 'dark' ? palette.success.main : COLOR_PALETTE.GREEN[7]),
  wordBreak: 'break-word',
};
